import DeveloperChargesPrint from "../components/DeveloperChargesPrint";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactDOM from 'react-dom';
const API_URL = process.env.REACT_APP_API_URL;
const DeveloperChargesList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [selectedReceipt, setSelectedReceipt] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");

  /* ================= FETCH DATA ================= */
 const fetchData = async () => {
  const res = await fetch(`${API_URL}/api/developer-charges`);
  const result = await res.json();

  if (Array.isArray(result)) {
    const sortedData = [...result].sort((a, b) =>
      b.receipt_no.localeCompare(a.receipt_no)
    );

    setData(sortedData);
  } else {
    setData([]);
  }
};

  useEffect(() => {
    fetchData();
  }, []);

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this receipt?")) return;

    await fetch(`${API_URL}/api/developer-charges/${id}`, {
      method: "DELETE",
    });

    fetchData();
    setSuccessMessage("Receipt deleted successfully ✅");
  };

  // CSV Export - Oldest First (Opposite of Table)
  const exportToCSV = () => {
    const reversedData = [...data].reverse();

    const headers = [
      "Sr No", "Receipt No", "Date", "Challan No", "Account No", "Developer Name",
      "Amount", "Amount in Words", "Fee Description", "Proposal No", "Payment Mode",
      "DD/Cheque No", "DD/Cheque Date", "Bank Name", "Remark", "Scheme Details"
    ];

    const rows = reversedData.map((r, index) => [
      index + 1,
      r.receipt_no || "",
      r.receipt_date?.slice(0, 10) || "",
      r.challan_no || "",
      r.account_no || "",
      r.developer_name || "",
      r.amount || "",
      r.amount_words || "",
      r.fee_description || "",
      r.proposal_no || "",
      r.payment_mode || "",
      r.dd_cheque_number || "",
      r.dd_date ? r.dd_date.slice(0, 10) : "",
      r.bank_name || "",
      r.remark || "",
      r.scheme_details_extra || ""
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map(row => row.map(field => `"${field}"`).join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = `Developer_Charges_List_${new Date().toISOString().slice(0,10)}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="pt-6 pb-8 max-w-7xl mx-auto">

      {/* HEADER */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-2xl p-6 shadow mb-6 flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-semibold">Developer Charges Receipts</h2>
          <p className="text-sm opacity-90 mt-1">Manage developer receipts and records</p>
        </div>

        <button
          onClick={exportToCSV}
          className="px-6 py-3 bg-white text-blue-700 font-semibold rounded-2xl hover:bg-blue-50 transition flex items-center gap-2 shadow"
        >
          Export to CSV
        </button>
      </div>

      {/* TABLE */}
      <div className="bg-white rounded-2xl shadow p-6">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">

            <thead className="bg-blue-600 text-white sticky top-0">
              <tr>
                <th className="px-4 py-4 text-left font-medium">Actions</th>
                <th className="px-4 py-4 text-left font-medium">#</th>
                <th className="px-4 py-4 text-left font-medium">Receipt No</th>
                <th className="px-4 py-4 text-left font-medium">Date</th>
                <th className="px-4 py-4 text-left font-medium">Challan No</th>
                <th className="px-4 py-4 text-left font-medium">Account No</th>
                <th className="px-4 py-4 text-left font-medium">Developer Name</th>
                <th className="px-4 py-4 text-left font-medium">Amount</th>
                <th className="px-4 py-4 text-left font-medium">Amount in Words</th>
                <th className="px-4 py-4 text-left font-medium">Fee Description</th>
                <th className="px-4 py-4 text-left font-medium">Proposal No</th>
                <th className="px-4 py-4 text-left font-medium">Payment Mode</th>
                <th className="px-4 py-4 text-left font-medium">DD/Cheque No</th>
                <th className="px-4 py-4 text-left font-medium">DD/Cheque Date</th>
                <th className="px-4 py-4 text-left font-medium">Bank Name</th>
                <th className="px-4 py-4 text-left font-medium">Remark</th>
                <th className="px-4 py-4 text-left font-medium">Scheme Details</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-100">
              {data.length === 0 ? (
                <tr>
                  <td colSpan={17} className="px-6 py-10 text-center text-gray-400">
                    No records found
                  </td>
                </tr>
              ) : (
                data.map((r, index) => (
                  <tr key={r.id} className="hover:bg-blue-50/60 transition">

                    {/* Actions Dropdown - First Column */}
                    <td className="px-4 py-4">
                      <div className="relative group">
                        <button className="px-5 py-2.5 text-xs font-medium rounded-2xl bg-gray-100 hover:bg-gray-200 text-gray-700 transition flex items-center gap-1 min-w-[90px]">
                          Actions ▾
                        </button>
                        <div className="absolute left-0 top-10 hidden group-hover:block bg-white border border-gray-200 rounded-xl shadow-lg z-50 w-52 overflow-hidden py-1">
                          <button
                            onClick={() => navigate(`/developer-charges/edit/${r.id}`, { state: { record: r } })}
                            className="w-full text-left px-5 py-2.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDelete(r.id)}
                            className="w-full text-left px-5 py-2.5 text-sm text-gray-700 hover:bg-red-50 hover:text-red-600 transition"
                          >
                            Delete
                          </button>
                          <button
                            onClick={() => setSelectedReceipt({ ...r, mode: "EN" })}
                            className="w-full text-left px-5 py-2.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition"
                          >
                             Print English Receipt
                          </button>
                          <button
                            onClick={() => setSelectedReceipt({ ...r, mode: "MR" })}
                            className="w-full text-left px-5 py-2.5 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition"
                          >
                            Print Marathi Receipt
                          </button>
                        </div>
                      </div>
                    </td>

                    <td className="px-4 py-4 text-gray-600 font-medium">{index + 1}</td>
                    <td className="px-4 py-4 font-medium text-gray-800">{r.receipt_no}</td>
                    <td className="px-4 py-4 text-gray-700">{r.receipt_date?.slice(0, 10)}</td>
                    <td className="px-4 py-4 text-gray-700">{r.challan_no || "-"}</td>
                    <td className="px-4 py-4 text-gray-700">{r.account_no || "-"}</td>
                    <td className="px-4 py-4 text-gray-700">{r.developer_name}</td>
                    <td className="px-4 py-4 text-gray-700 font-medium">₹ {r.amount}</td>
                    <td className="px-4 py-4 text-gray-600 text-sm">{r.amount_words}</td>
                    <td className="px-4 py-4 text-gray-600 text-sm max-w-xs truncate" title={r.fee_description}>
                      {r.fee_description || "-"}
                    </td>
                    <td className="px-4 py-4 text-gray-700">{r.proposal_no || "-"}</td>
                    <td className="px-4 py-4 text-gray-700">{r.payment_mode}</td>
                    <td className="px-4 py-4 text-gray-700">{r.dd_cheque_number || "-"}</td>
                    <td className="px-4 py-4 text-gray-700">
                      {r.dd_date ? r.dd_date.slice(0, 10) : "-"}
                    </td>
                    <td className="px-4 py-4 text-gray-700">{r.bank_name || "-"}</td>
                    <td className="px-4 py-4 text-gray-600 text-sm max-w-xs truncate" title={r.remark}>
                      {r.remark || "-"}
                    </td>
                    <td className="px-4 py-4 text-gray-600 text-sm max-w-xs truncate" title={r.scheme_details_extra}>
                      {r.scheme_details_extra || "-"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* SUCCESS MODAL */}
      {successMessage && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-8 text-center">
            <div className="text-5xl mb-4">✅</div>
            <h2 className="text-xl font-semibold mb-2">Success</h2>
            <p className="text-gray-600 mb-6">{successMessage}</p>
            <button
              onClick={() => setSuccessMessage("")}
              className="px-8 py-3 bg-green-600 text-white rounded-2xl hover:bg-green-700 transition font-medium"
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* PRINT COMPONENT */}
      {selectedReceipt && ReactDOM.createPortal(
        <DeveloperChargesPrint
          data={selectedReceipt}
          onClose={() => setSelectedReceipt(null)}
        />,
        document.getElementById('print-root')
      )}
    </div>
  );
};

export default DeveloperChargesList;